var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Information Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.3125 10.125H8.875C8.64294 10.125 8.42038 10.0328 8.25628 9.86872C8.09219 9.70462 8 9.48206 8 9.25V7.0625C8 6.94647 7.95391 6.83519 7.87186 6.75314C7.78981 6.67109 7.67853 6.625 7.5625 6.625H7.125",
    stroke: "#60666C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.78125 4.875C7.72323 4.875 7.66759 4.85195 7.62657 4.81093C7.58555 4.76991 7.5625 4.71427 7.5625 4.65625C7.5625 4.59823 7.58555 4.54259 7.62657 4.50157C7.66759 4.46055 7.72323 4.4375 7.78125 4.4375",
    stroke: "#60666C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.78125 4.875C7.83927 4.875 7.89491 4.85195 7.93593 4.81093C7.97695 4.76991 8 4.71427 8 4.65625C8 4.59823 7.97695 4.54259 7.93593 4.50157C7.89491 4.46055 7.83927 4.4375 7.78125 4.4375",
    stroke: "#60666C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8 14.0625C11.6242 14.0625 14.5625 11.1242 14.5625 7.5C14.5625 3.87575 11.6242 0.9375 8 0.9375C4.37575 0.9375 1.4375 3.87575 1.4375 7.5C1.4375 11.1242 4.37575 14.0625 8 14.0625Z",
    stroke: "#60666C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.4515cacf651d194f8203185609db5627.svg";
export { ForwardRef as ReactComponent };